import request from '@/utils/request'

// 获取图形验证码
export function getCaptcha() {
  return request({
    url: '/third_party/captcha',
    method: 'get',
    responseType: 'blob',
  })
}

// 发送短信验证码
export function sendSmsCode(data: {
  captcha?: string,
  phoneAreaPrefix: string,
  phoneNumber: string,
  type: number //类型空 0 登录 1注册 2 修改密码
}) {
  return request({
    url: '/third_party/send_msg',
    method: 'post',
    data
  })
}

// 登录
export function loginApi(data: {
  captcha: string,
  password: string,
  phoneAreaPrefix: string,
  phoneNumber: string,
  type: number //登录类型空 0 账密登录 1 验证码 2 支付宝登录
}) {
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}

// 注册
export function registerApi(data: {
  captcha: string,
  clientType: string,
  onlyCode?: string,
  password: string,
  phoneAreaPrefix: string,
  phoneNumber: string,
  inviteCode: string
}) {
  return request({
    url: '/user/register',
    method: 'post',
    data
  })
}

// 忘记密码
export function forgetPwdApi(data: {
  captcha: string,
  clientType: string,
  onlyCode?: string,
  password: string,
  phoneAreaPrefix: string,
  phoneNumber: string
}) {
  return request({
    url: '/user/modify_pwd',
    method: 'post',
    data
  })
}

// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/user/curr_user',
    method: 'get',
  })
}

// 实名认证
export function realNameAuth(data: {
  idCard: string,
  payPassword: string,
  phoneNumber: string,
  realName: string
}) {
  return request({
    url: '/user/authentication',
    method: 'post',
    data
  })
}

//上传头像
export function uploadAvatar(data: {
  file: File
}) {
  return request({
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    url: '/user/modify_avatar',
    method: 'post',
    data
  })
}

// 修改用户信息
export function modifyUserInfo(data: {
  avatar?: string,
  birthday?: string,
  gender?: number,
  nickName?: string,
  slogan?: string
}) {
  return request({
    url: '/user/modify_base',
    method: 'post',
    data
  })
}


//文件上传
export const uploadFile = (formData: FormData) => {
  return request({
    url: '/third_party/upload',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  });
};